// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: K63AXAYlTq
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  useTrigger
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { Reveal } from "@plasmicpkgs/react-awesome-reveal";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicContactDiv.module.css"; // plasmic-import: K63AXAYlTq/css

createPlasmicElementProxy;

export const PlasmicContactDiv__VariantProps = new Array();

export const PlasmicContactDiv__ArgProps = new Array();

const $$ = {};

function PlasmicContactDiv__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const [isGreenButton4Hover, triggerGreenButton4HoverProps] = useTrigger(
    "useHover",
    {}
  );
  const triggers = {
    hover_greenButton4: isGreenButton4Hover
  };
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <Reveal
        data-plasmic-name={"reveal"}
        data-plasmic-override={overrides.reveal}
        cascade={true}
        className={classNames("__wab_instance", sty.reveal)}
        triggerOnce={true}
      >
        <div className={classNames(projectcss.all, sty.freeBox__cEoG)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text___4A3K5
            )}
          >
            {
              " Every location has a world of data.\nHow much have you captured about yours?"
            }
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox___0EGX)}>
          {(
            triggers.hover_greenButton4
              ? (() => {
                  try {
                    return true;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return true;
                    }
                    throw e;
                  }
                })()
              : true
          ) ? (
            <PlasmicLink__
              data-plasmic-name={"greenButton4"}
              data-plasmic-override={overrides.greenButton4}
              className={classNames(
                projectcss.all,
                projectcss.a,
                sty.greenButton4
              )}
              href={`/contact-us`}
              platform={"react"}
              data-plasmic-trigger-props={[triggerGreenButton4HoverProps]}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__mSvz1
                )}
              >
                {"Contact Us"}
              </div>
            </PlasmicLink__>
          ) : null}
        </div>
      </Reveal>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "reveal", "greenButton4"],
  reveal: ["reveal", "greenButton4"],
  greenButton4: ["greenButton4"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicContactDiv__ArgProps,
          internalVariantPropNames: PlasmicContactDiv__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicContactDiv__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicContactDiv";
  } else {
    func.displayName = `PlasmicContactDiv.${nodeName}`;
  }
  return func;
}

export const PlasmicContactDiv = Object.assign(
  // Top-level PlasmicContactDiv renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    reveal: makeNodeComponent("reveal"),
    greenButton4: makeNodeComponent("greenButton4"),
    // Metadata about props expected for PlasmicContactDiv
    internalVariantProps: PlasmicContactDiv__VariantProps,
    internalArgProps: PlasmicContactDiv__ArgProps
  }
);

export default PlasmicContactDiv;
/* prettier-ignore-end */
